export default function Footer() {
   return (
      <footer>
         <p className="credits">
            Coded by{" "}
            <a
               href="https://github.com/di-legorreta"
               target="_blank"
               rel="noopener"
            >
               Diana Legorreta
            </a>{" "}
            open-sourced on{" "}
            <a
               href="https://github.com/di-legorreta/weather-app-week4"
               target="_blank"
               rel="noopener"
            >
               GitHub
            </a>{" "}
            and hosted on{" "}
            <a
               href="https://weather-app-week4.pages.dev/"
               target="_blank"
               rel="noopener"
            >
               Cloudflare Pages
            </a>
         </p>
      </footer>
   );
}
